<div class="input-field-name" *ngIf="labelName">
  <span *ngIf="!readOnlyMode || !hideLabel">{{ labelName}}</span>
  <span class="optional" *ngIf="subLabelName">{{subLabelName}}</span>
  <!-- <span class="optional" *ngIf="!isRequiredField">({{ OPTIONAL }})</span> -->
</div>
<div *ngIf="readOnlyMode && inputFormControl && !multiSelection" class="readOnly">{{inputFormControl.value}}</div>
<div class="input-section" *ngIf="!readOnlyMode">
  <input
    type="text"
    [ngClass]="
      inputFormControl &&
      (submitted || inputFormControl.touched) &&
      inputFormControl.errors
        ? 'error-input'
        : ''
    "
    [formControl]="inputFormControl"
    placeholder="{{ placeHolder }}"
  />
  <i *ngIf="!inputFormControl?.value" class="fa fa-search search-icon" aria-hidden="true"></i>
  <i *ngIf="inputFormControl?.value" class="fa fa-times search-icon error" aria-hidden="true" (click)="clear()"></i>

  <div class="search-bar-result" [hidden]="!(users && searchTxt && searchTxt.length)">
    <div
      class="list cursor-pointer"
      *ngFor="let item of users; let i = index"
      (click)="onSelect(item)"
    >
    <span class="users">
      <span innerHtml="{{ item.firstName | highlightText : searchTxt }} {{item.lastName | highlightText : searchTxt }}"></span> -
      <!-- <div class="spacer"></div> -->
      <span class="disable-txt">{{ item.currentPosition }}</span>
    </span>
    </div>
  </div>
</div>
<div
  class="error"
  *ngIf="
    inputFormControl &&
    !readOnlyMode &&
    (submitted || inputFormControl.touched) &&
    inputFormControl.errors
  "
>
  <div *ngIf="inputFormControl.errors.required">
    {{ labelName }} is required.
  </div>
</div>
